<template>
    <select
        name="reminder_month"
        placeholder="Month"
        class="form-control"
        :value="value"
        @input="$emit('input', $event.target.value)"
    >
        <option
            :value="null"
            disabled
        >
            Choose month...
        </option>
        <option value="1">
            January
        </option>
        <option value="2">
            Feburary
        </option>
        <option value="3">
            March
        </option>
        <option value="4">
            April
        </option>
        <option value="5">
            May
        </option>
        <option value="6">
            June
        </option>
        <option value="7">
            July
        </option>
        <option value="8">
            August
        </option>
        <option value="9">
            September
        </option>
        <option value="10">
            October
        </option>
        <option value="11">
            November
        </option>
        <option value="12">
            December
        </option>
        <option value="13">
            Over Due
        </option>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String],
            default: 1,
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MonthSelectorComponent.vue